(function () {
  function getBoolean(value, fallback) {
    if (value === 'true') return true
    if (value === 'false') return false
    return fallback
  }

  function syncSlideVideos(sliderElement) {
    sliderElement.querySelectorAll('[data-wd-banner-video]').forEach(function (video) {
      var slide = video.closest('.splide__slide')

      if (slide && slide.classList.contains('is-active') && !document.hidden) {
        video.play().catch(function () {})
      } else {
        video.pause()
      }
    })
  }

  function initBannerSlider(sliderElement) {
    if (!sliderElement || sliderElement.dataset.webdevMounted === 'true') return
    if (typeof window.Splide === 'undefined') return

    var slider = new window.Splide(sliderElement, {
      type: sliderElement.dataset.type || 'slide',
      perPage: 1,
      perMove: 1,
      gap: 0,
      arrows: false,
      pagination: true,
      drag: true,
      rewind: getBoolean(sliderElement.dataset.rewind, true),
      autoplay: getBoolean(sliderElement.dataset.autoplay, false),
      interval: parseInt(sliderElement.dataset.interval, 10) || 5000,
      speed: parseInt(sliderElement.dataset.speed, 10) || 700,
      pauseOnHover: getBoolean(sliderElement.dataset.pauseHover, true),
      pauseOnFocus: getBoolean(sliderElement.dataset.pauseFocus, true),
      updateOnMove: true,
      i18n: {
        prev: 'Previous banner slide',
        next: 'Next banner slide',
        first: 'Go to first banner slide',
        last: 'Go to last banner slide',
        slideX: 'Go to banner slide %s',
        pageX: 'Go to page %s',
        play: 'Start banner autoplay',
        pause: 'Pause banner autoplay',
        carousel: 'banner carousel',
        slide: 'banner slide',
        select: 'Select a banner slide to show',
        slideLabel: '%s of %s'
      },
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: 'pause'
      }
    })

    slider.on('mounted moved active visible', function () {
      syncSlideVideos(sliderElement)
    })

    slider.on('destroy', function () {
      sliderElement.dataset.webdevMounted = 'false'
    })

    slider.mount()
    sliderElement.dataset.webdevMounted = 'true'
    sliderElement.webdevBannerSlider = slider
    syncSlideVideos(sliderElement)
  }

  function initBannerSliders() {
    document.querySelectorAll('[data-wd-banner-slider]').forEach(initBannerSlider)
  }

  function initTestimonialSlider(sliderElement) {
    if (!sliderElement || sliderElement.dataset.webdevMounted === 'true') return
    if (typeof window.Splide === 'undefined') return

    var slider = new window.Splide(sliderElement, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 0,
      arrows: false,
      pagination: true,
      drag: true,
      rewind: getBoolean(sliderElement.dataset.rewind, true),
      autoplay: getBoolean(sliderElement.dataset.autoplay, false),
      interval: parseInt(sliderElement.dataset.interval, 10) || 5000,
      speed: parseInt(sliderElement.dataset.speed, 10) || 700,
      pauseOnHover: getBoolean(sliderElement.dataset.pauseHover, true),
      pauseOnFocus: getBoolean(sliderElement.dataset.pauseFocus, true),
      updateOnMove: true,
      i18n: {
        prev: 'Previous testimonial',
        next: 'Next testimonial',
        first: 'Go to first testimonial',
        last: 'Go to last testimonial',
        slideX: 'Go to testimonial %s',
        pageX: 'Go to page %s',
        play: 'Start testimonial autoplay',
        pause: 'Pause testimonial autoplay',
        carousel: 'testimonial carousel',
        slide: 'testimonial',
        select: 'Select a testimonial to show',
        slideLabel: '%s of %s'
      },
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: 'pause'
      }
    })

    slider.on('destroy', function () {
      sliderElement.dataset.webdevMounted = 'false'
    })

    slider.mount()
    sliderElement.dataset.webdevMounted = 'true'
    sliderElement.webdevTestimonialSlider = slider
  }

  function initTestimonialSliders() {
    document.querySelectorAll('[data-wd-testimonial-slider]').forEach(initTestimonialSlider)
  }

  function resetCustomVideo(videoWrap) {
    var video = videoWrap.querySelector('[data-custom-video-media]')

    videoWrap.classList.remove('is-playing')

    if (video) {
      video.pause()
      video.currentTime = 0
    }
  }

  function initCustomVideo(videoWrap) {
    if (!videoWrap || videoWrap.dataset.webdevVideoMounted === 'true') return

    var trigger = videoWrap.querySelector('[data-custom-video-trigger]')
    var video = videoWrap.querySelector('[data-custom-video-media]')

    if (!trigger || !video) return

    trigger.addEventListener('click', function () {
      videoWrap.classList.add('is-playing')
      video.play().catch(function () {})
    })

    video.addEventListener('ended', function () {
      resetCustomVideo(videoWrap)
    })

    videoWrap.dataset.webdevVideoMounted = 'true'
  }

  function initCustomVideos() {
    document.querySelectorAll('[data-custom-video]').forEach(initCustomVideo)
  }

  function mountCustomProductMediaSlider(sliderElement) {
    if (!sliderElement || sliderElement.dataset.webdevMounted === 'true') return
    if (typeof window.Splide === 'undefined') return

    var slideCount = sliderElement.querySelectorAll('.custom-product-card__slide').length
    if (slideCount < 2) {
      sliderElement.classList.add('is-static')
      sliderElement.dataset.webdevMounted = 'true'
      return
    }

    var slider = new window.Splide(sliderElement, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 0,
      arrows: true,
      pagination: false,
      drag: true,
      speed: 450,
      rewind: false,
      lazyLoad: false,
      i18n: {
        prev: 'Previous product image',
        next: 'Next product image',
        carousel: 'product media carousel',
        slide: 'product image',
        slideLabel: '%s of %s'
      },
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0
      }
    })

    slider.on('destroy', function () {
      sliderElement.dataset.webdevMounted = 'false'
    })

    slider.on('mounted', function () {
      window.requestAnimationFrame(function () {
        slider.refresh()
        sliderElement.classList.add('is-loop-ready')
      })
    })

    slider.mount()
    sliderElement.dataset.webdevMounted = 'true'
    sliderElement.webdevProductMediaSlider = slider
  }

  function bindCustomProductCard(card) {
    if (!card || card.dataset.webdevCardMounted === 'true') return

    card.addEventListener('click', function (event) {
      if (event.target.closest('a, button')) return

      var url = card.dataset.productUrl
      if (url) window.location.href = url
    })

    card.dataset.webdevCardMounted = 'true'
  }

  function initCustomProductMediaSliders() {
    document.querySelectorAll('[data-custom-product-card]').forEach(bindCustomProductCard)

    document.querySelectorAll('[data-custom-product-media-slider]').forEach(function (sliderElement) {
      if (sliderElement.dataset.webdevHoverBound === 'true') return

      var mount = function () {
        mountCustomProductMediaSlider(sliderElement)
      }

      sliderElement.addEventListener('mouseenter', mount, { once: true })
      sliderElement.addEventListener('focusin', mount, { once: true })
      sliderElement.addEventListener('touchstart', mount, { once: true, passive: true })
      sliderElement.dataset.webdevHoverBound = 'true'
    })
  }

  function updateQuickAtcCard(productSection, variant) {
    if (!productSection || !variant) return

    productSection.querySelectorAll('[data-wd-quick-atc-card]').forEach(function (card) {
      var input = card.querySelector('[data-wd-quick-variant-id]')
      var button = card.querySelector('[name="add"]')
      var label = card.querySelector('[data-wd-quick-atc-text]')

      if (input) input.value = variant.id

      if (button) {
        button.disabled = !variant.available
      }

      if (label && button) {
        label.textContent = variant.available ? button.dataset.addToCartText : 'Sold out'
      }
    })
  }

  function getMainProductQuantity(productSection, form) {
    if (!productSection) return 1

    var source = form && !form.closest('[data-wd-quick-atc-card]')
      ? form.querySelector('[name="quantity"]')
      : productSection.querySelector('.wd-product-info .js-product-form [name="quantity"]')

    var quantity = parseInt(source && source.value, 10)
    return quantity > 0 ? quantity : 1
  }

  function updateProductAddonQuickImage(productSection, selectedButton) {
    if (!productSection) return

    productSection.querySelectorAll('[data-wd-quick-image]').forEach(function (image) {
      if (!image.dataset.defaultSrc) {
        image.dataset.defaultSrc = image.getAttribute('src') || ''
        image.dataset.defaultSrcset = image.getAttribute('srcset') || ''
        image.dataset.defaultAlt = image.getAttribute('alt') || ''
      }

      if (selectedButton && selectedButton.dataset.addonImageSrc) {
        image.setAttribute('src', selectedButton.dataset.addonImageSrc)
        image.setAttribute('srcset', selectedButton.dataset.addonImageSrcset || selectedButton.dataset.addonImageSrc)
        image.setAttribute('alt', selectedButton.dataset.addonImageAlt || selectedButton.dataset.addonTitle || image.dataset.defaultAlt)
      } else {
        image.setAttribute('src', image.dataset.defaultSrc)
        image.setAttribute('srcset', image.dataset.defaultSrcset)
        image.setAttribute('alt', image.dataset.defaultAlt)
      }
    })
  }

  function formatProductAddonMoney(cents, templateText) {
    var text = (templateText || '').trim()
    var firstDigit = text.search(/\d/)
    var lastDigit = Math.max(text.lastIndexOf('0'), text.lastIndexOf('1'), text.lastIndexOf('2'), text.lastIndexOf('3'), text.lastIndexOf('4'), text.lastIndexOf('5'), text.lastIndexOf('6'), text.lastIndexOf('7'), text.lastIndexOf('8'), text.lastIndexOf('9'))

    if (firstDigit > -1 && lastDigit >= firstDigit) {
      var prefix = text.slice(0, firstDigit)
      var suffix = text.slice(lastDigit + 1)
      var numberPart = text.slice(firstDigit, lastDigit + 1)
      var decimalSeparator = numberPart.lastIndexOf(',') > numberPart.lastIndexOf('.') ? ',' : '.'
      var thousandsSeparator = decimalSeparator === ',' ? '.' : ','
      var value = (cents / 100).toFixed(2).split('.')
      var whole = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)

      return prefix + whole + decimalSeparator + value[1] + suffix
    }

    if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
      return theme.Shopify.formatMoney(cents, theme.settings && theme.settings.moneyWithCurrencyFormat)
    }

    return (cents / 100).toFixed(2)
  }

  function updateProductAddonPrice(productSection, selectedButton) {
    if (!productSection) return

    var priceWrapper = productSection.querySelector('.js-product-price')
    if (!priceWrapper) return

    var priceTarget = priceWrapper.querySelector('.price__current')
    if (!priceTarget) return

    if (!priceWrapper.dataset.defaultPriceHtml) {
      priceWrapper.dataset.defaultPriceHtml = priceTarget.innerHTML
      priceWrapper.dataset.defaultPriceText = priceTarget.textContent || priceTarget.innerText || ''
    }

    var basePrice = parseInt(priceWrapper.dataset.productBasePrice, 10)
    if (!basePrice) return

    if (selectedButton && selectedButton.dataset.addonPrice) {
      var addonPrice = parseInt(selectedButton.dataset.addonPrice, 10) || 0
      priceTarget.textContent = formatProductAddonMoney(basePrice + addonPrice, priceWrapper.dataset.defaultPriceText)
    } else {
      priceTarget.innerHTML = priceWrapper.dataset.defaultPriceHtml
    }
  }

  function initProductAddonPicker(picker) {
    if (!picker || picker.dataset.webdevMounted === 'true') return

    var productSection = picker.closest('.js-product')
    var buttons = Array.prototype.slice.call(picker.querySelectorAll('[data-product-addon-item]'))
    var filterButtons = Array.prototype.slice.call(picker.querySelectorAll('[data-product-addon-filter]'))
    var list = picker.querySelector('.wd-product-addons__list')
    var prevButton = picker.querySelector('[data-product-addon-prev]')
    var nextButton = picker.querySelector('[data-product-addon-next]')
    var progressCurrent = picker.querySelector('[data-product-addon-progress-current]')
    var progressTotal = picker.querySelector('[data-product-addon-progress-total]')
    var progressBar = picker.querySelector('[data-product-addon-progress-bar]')

    function getVisibleAddonButtons() {
      return buttons.filter(function (button) {
        return !button.hidden
      })
    }

    function updateProductAddonProgress() {
      var visibleButtons = getVisibleAddonButtons()
      var total = visibleButtons.length

      if (!total) {
        if (progressCurrent) progressCurrent.textContent = '0'
        if (progressTotal) progressTotal.textContent = '0'
        if (progressBar) progressBar.style.width = '0%'
        return
      }

      var firstVisibleIndex = 0
      var visibleEnd = Math.min(total, 3)

      if (list && list.scrollWidth > list.clientWidth) {
        var firstButton = visibleButtons[0]
        var itemStep = firstButton ? firstButton.offsetWidth + parseFloat(window.getComputedStyle(list).columnGap || window.getComputedStyle(list).gap || 0) : 1
        firstVisibleIndex = Math.round(list.scrollLeft / Math.max(itemStep, 1))
        firstVisibleIndex = Math.max(0, Math.min(firstVisibleIndex, total - 1))
        visibleEnd = Math.min(total, firstVisibleIndex + 3)
      }

      if (progressCurrent) progressCurrent.textContent = String(visibleEnd)
      if (progressTotal) progressTotal.textContent = String(total)
      if (progressBar) progressBar.style.width = (visibleEnd / total * 100) + '%'

      if (prevButton) {
        prevButton.hidden = total <= 3
        prevButton.disabled = firstVisibleIndex <= 0
      }

      if (nextButton) {
        nextButton.hidden = total <= 3
        nextButton.disabled = visibleEnd >= total
      }
    }

    function scrollProductAddonList(direction) {
      if (!list) return

      var visibleButtons = getVisibleAddonButtons()
      var total = visibleButtons.length
      if (total <= 3) return

      var firstButton = visibleButtons[0]
      var itemStep = firstButton ? firstButton.offsetWidth + parseFloat(window.getComputedStyle(list).columnGap || window.getComputedStyle(list).gap || 0) : 1
      var currentIndex = Math.round(list.scrollLeft / Math.max(itemStep, 1))
      var nextIndex = Math.max(0, Math.min(currentIndex + direction, total - 3))

      list.scrollTo({
        left: nextIndex * itemStep,
        behavior: 'smooth'
      })
    }

    function updateProductAddonVisibility() {
      var visibleButtons = getVisibleAddonButtons()

      buttons.forEach(function (button) {
        button.setAttribute('tabindex', '-1')
      })

      visibleButtons.forEach(function (button) {
        button.removeAttribute('tabindex')
      })

      if (list) list.scrollLeft = 0
      window.requestAnimationFrame(updateProductAddonProgress)
    }

    function clearProductAddonSelection() {
      buttons.forEach(function (item) {
        item.classList.remove('is-selected')
        item.setAttribute('aria-pressed', 'false')
      })

      picker.removeAttribute('data-selected-addon-variant-id')
      picker.removeAttribute('data-selected-addon-title')
      updateProductAddonQuickImage(productSection, null)
      updateProductAddonPrice(productSection, null)
    }

    function applyProductAddonFilter(tag) {
      buttons.forEach(function (button) {
        var itemTags = (button.dataset.addonTags || '').split(/\s+/)
        var isVisible = !tag || itemTags.indexOf(tag) > -1

        button.hidden = !isVisible

        if (!isVisible && button.classList.contains('is-selected')) {
          clearProductAddonSelection()
        }
      })

      updateProductAddonVisibility()
    }

    filterButtons.forEach(function (filterButton) {
      filterButton.addEventListener('click', function () {
        var tag = filterButton.dataset.productAddonFilter || ''
        var isSelected = filterButton.getAttribute('aria-pressed') === 'true'

        // The add-on filters behave as tabs: one option must always stay active.
        if (isSelected) return

        filterButtons.forEach(function (item) {
          item.classList.remove('is-active')
          item.setAttribute('aria-pressed', 'false')
        })

        filterButton.classList.add('is-active')
        filterButton.setAttribute('aria-pressed', 'true')
        applyProductAddonFilter(tag)
      })
    })

    if (list) {
      list.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateProductAddonProgress)
      }, { passive: true })
    }

    window.addEventListener('resize', updateProductAddonProgress)

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        scrollProductAddonList(-1)
      })
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollProductAddonList(1)
      })
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var isSelected = button.classList.contains('is-selected')

        if (isSelected) {
          clearProductAddonSelection()
          return
        }

        clearProductAddonSelection()
        button.classList.add('is-selected')
        button.setAttribute('aria-pressed', 'true')
        picker.dataset.selectedAddonVariantId = button.dataset.addonVariantId
        picker.dataset.selectedAddonTitle = button.dataset.addonTitle || ''
        updateProductAddonQuickImage(productSection, button)
        updateProductAddonPrice(productSection, button)
      })
    })

    if (filterButtons.length) {
      filterButtons[0].classList.add('is-active')
      filterButtons[0].setAttribute('aria-pressed', 'true')
      applyProductAddonFilter(filterButtons[0].dataset.productAddonFilter || '')
    } else {
      updateProductAddonVisibility()
    }

    picker.dataset.webdevMounted = 'true'
  }

  function initProductAddonPickers() {
    document.querySelectorAll('[data-product-addon-picker]').forEach(initProductAddonPicker)
  }

  function setAddonFormState(form, isLoading) {
    if (!form) return

    var button = form.querySelector('[name="add"]')
    if (!button) return

    if (isLoading) {
      button.setAttribute('aria-disabled', 'true')
      button.setAttribute('disabled', 'disabled')
      button.classList.add('is-loading')
      return
    }

    button.classList.remove('is-loading')
    button.classList.add('is-success')
    button.removeAttribute('aria-disabled')

    window.setTimeout(function () {
      button.classList.remove('is-success')
      button.removeAttribute('disabled')
    }, 2000)
  }

  function setAddonFormError(form, message) {
    if (!form) return

    var errorElement = form.querySelector('.js-form-error')
    if (!errorElement) return

    errorElement.hidden = !message
    if (message) errorElement.textContent = message
  }

  async function handleProductAddonSubmit(event) {
    var form = event.target
    if (!form || !form.classList.contains('js-product-form')) return
    if (window.location.pathname === theme.routes.cart) return

    var productSection = form.closest('.js-product')
    var picker = productSection && productSection.querySelector('[data-product-addon-picker]')
    var addOnVariantId = picker && picker.dataset.selectedAddonVariantId
    if (!productSection || !addOnVariantId) return

    event.preventDefault()
    event.stopImmediatePropagation()

    var mainVariantInput = form.querySelector('[name="id"]')
    var mainVariantId = mainVariantInput && mainVariantInput.value
    if (!mainVariantId) return

    var quantity = getMainProductQuantity(productSection, form)
    var cartDrawer = document.querySelector('cart-drawer')
    var sections = cartDrawer ? cartDrawer.dataset.section + ',cart-icon-bubble' : 'cart-icon-bubble'

    setAddonFormError(form, false)
    setAddonFormState(form, true)

    try {
      var response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: mainVariantId,
              quantity: quantity
            },
            {
              id: addOnVariantId,
              quantity: quantity
            }
          ],
          sections: sections,
          sections_url: window.location.pathname
        })
      })

      var data = await response.json()
      var error = typeof data.description === 'string' ? data.description : data.message

      if (!response.ok || data.status) {
        setAddonFormError(form, error || 'Unable to add products to cart.')
        throw new Error(response.status)
      }

      var cartIconBubble = document.getElementById('cart-icon-bubble')
      if (cartIconBubble && data.sections && data.sections['cart-icon-bubble']) {
        cartIconBubble.innerHTML = data.sections['cart-icon-bubble']
      }

      if (theme.settings.afterAtc === 'page') {
        window.setTimeout(function () {
          window.location.href = theme.routes.cart
        }, 300)
      } else if (cartDrawer && data.sections) {
        cartDrawer.renderContents(data, theme.settings.afterAtc === 'drawer')
      }

      setAddonFormState(form, false)
    } catch (error) {
      form.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: {
          error: error && error.message
        }
      }))

      var button = form.querySelector('[name="add"]')
      if (button) {
        button.classList.remove('is-loading')
        button.classList.remove('is-success')
        button.removeAttribute('disabled')
        button.removeAttribute('aria-disabled')
      }

      if (cartDrawer) cartDrawer.refresh(true)
    }
  }

  function initProductDetailGallery(gallery) {
    if (!gallery || gallery.dataset.webdevMounted === 'true') return
    if (typeof window.Splide === 'undefined') return

    var mainElement = gallery.querySelector('[data-wd-product-main-gallery]')
    var thumbElement = gallery.querySelector('[data-wd-product-thumb-gallery]')
    if (!mainElement) return
    var realMediaCount = parseInt(mainElement.dataset.realMediaCount, 10) || mainElement.querySelectorAll('.splide__slide:not(.wd-product-gallery__slide--duplicate)').length

    if (window.matchMedia('(max-width: 749px)').matches) {
      mainElement.querySelectorAll('.wd-product-gallery__slide--duplicate').forEach(function (slide) {
        slide.remove()
      })
    }

    var mainSlider = new window.Splide(mainElement, {
      type: 'slide',
      perPage: 2.2,
      perMove: 1,
      gap: 0,
      arrows: false,
      pagination: false,
      drag: true,
      flickPower: 180,
      flickMaxPages: 1,
      waitForTransition: false,
      focus: 0,
      trimSpace: true,
      speed: 650,
      rewind: false,
      i18n: {
        carousel: 'product media gallery',
        slide: 'product media',
        slideLabel: '%s of %s'
      },
      breakpoints: {
        1199: {
          perPage: 1.65
        },
        749: {
          perPage: 1
        }
      },
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0
      }
    })

    var thumbSlider = null
    if (thumbElement && realMediaCount <= 6) {
      thumbElement.classList.add('wd-product-gallery__thumbs--static')
    }

    if (thumbElement && realMediaCount > 6) {
      thumbSlider = new window.Splide(thumbElement, {
        type: 'slide',
        direction: 'ttb',
        height: '328px',
        fixedHeight: '53px',
        fixedWidth: '58px',
        perPage: 6,
        perMove: 1,
        gap: 0,
        arrows: false,
        pagination: false,
        isNavigation: false,
        drag: true,
        wheel: false,
        speed: 450,
        breakpoints: {
          749: {
            direction: 'ltr',
            height: '53px',
            fixedHeight: '52px',
            fixedWidth: '48px',
            perPage: 6,
            gap: 0
          }
        },
        i18n: {
          carousel: 'product thumbnail gallery',
          slide: 'product thumbnail',
          slideLabel: '%s of %s'
        }
      })
    }

    function normalizeGalleryIndex(index, total) {
      if (!total) return 0
      return ((index % total) + total) % total
    }

    function getProductThumbButtons() {
      if (!thumbElement) return []

      return Array.prototype.slice.call(thumbElement.querySelectorAll('.wd-product-gallery__thumb')).filter(function (button) {
        return !button.classList.contains('splide__slide--clone')
      })
    }

    function alignProductThumbRail(startIndex) {
      if (!thumbElement || !thumbSlider) return

      var list = thumbElement.querySelector('.splide__list')
      if (!list) return

      window.requestAnimationFrame(function () {
        var isMobile = window.matchMedia('(max-width: 749px)').matches
        var distance = startIndex * (isMobile ? 48 : 53)
        list.style.transform = isMobile ? 'translateX(-' + distance + 'px)' : 'translateY(-' + distance + 'px)'
      })
    }

    function setActiveProductThumb(index, moveThumbSlider) {
      var buttons = getProductThumbButtons()
      var activeIndex = normalizeGalleryIndex(index, realMediaCount)

      buttons.forEach(function (button, buttonIndex) {
        if (buttonIndex === activeIndex) {
          button.classList.add('is-active')
          button.setAttribute('aria-current', 'true')
        } else {
          button.classList.remove('is-active')
          button.removeAttribute('aria-current')
        }
      })

      if (moveThumbSlider && thumbSlider && buttons.length > 6) {
        var maxThumbStart = Math.max(buttons.length - 6, 0)
        var thumbStart = activeIndex >= buttons.length - 2 ? maxThumbStart : Math.max(activeIndex - 4, 0)
        thumbStart = Math.min(thumbStart, maxThumbStart)
        thumbSlider.go(thumbStart)
        alignProductThumbRail(thumbStart)
      }
    }

    mainSlider.on('destroy', function () {
      gallery.dataset.webdevMounted = 'false'
    })

    mainSlider.on('mounted moved', function () {
      setActiveProductThumb(mainSlider.index, true)
    })

    mainSlider.mount()
    if (thumbSlider) thumbSlider.mount()

    if (thumbElement) {
      thumbElement.addEventListener('click', function (event) {
        var button = event.target.closest('.wd-product-gallery__thumb')
        if (!button || button.classList.contains('splide__slide--clone')) return

        var buttons = getProductThumbButtons()
        var index = buttons.indexOf(button)
        if (index < 0) return

        mainSlider.go(index)
        setActiveProductThumb(index, true)
      })
    }

    setActiveProductThumb(mainSlider.index, false)

    gallery.webdevMainProductGallery = mainSlider
    gallery.webdevThumbProductGallery = thumbSlider
    gallery.dataset.webdevMounted = 'true'
  }

  function initProductGalleryZoom(gallery) {
    if (!gallery || gallery.dataset.webdevZoomMounted === 'true') return

    var zoomTemplate = gallery.querySelector('.js-media-zoom-template')
    if (!zoomTemplate) return

    gallery.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-wd-gallery-zoom-open]')
      if (!trigger || !gallery.contains(trigger)) return

      event.preventDefault()

      if (!gallery.webdevZoomModal || !document.body.contains(gallery.webdevZoomModal)) {
        gallery.webdevZoomModal = zoomTemplate.content.firstElementChild.cloneNode(true)
        document.body.appendChild(gallery.webdevZoomModal)
      }

      var mediaId = trigger.dataset.mediaId || (trigger.closest('[data-media-id]') && trigger.closest('[data-media-id]').dataset.mediaId)
      var zoom = gallery.webdevZoomModal.querySelector('gallery-zoom')

      gallery.webdevZoomModal.open(trigger)

      if (zoom && typeof zoom.init === 'function') {
        zoom.init(mediaId)
        zoom.focus()
      }
    })

    gallery.dataset.webdevZoomMounted = 'true'
  }

  function initProductDetailGalleries() {
    document.querySelectorAll('[data-wd-product-gallery]').forEach(initProductDetailGallery)
    document.querySelectorAll('[data-wd-product-gallery]').forEach(initProductGalleryZoom)

    document.querySelectorAll('.js-product').forEach(function (productSection) {
      if (productSection.dataset.webdevQuickAtcMounted === 'true') return

      productSection.addEventListener('on:variant:change', function (event) {
        if (event.detail && event.detail.variant) {
          updateQuickAtcCard(productSection, event.detail.variant)
          productSection.querySelectorAll('.js-product-price').forEach(function (priceWrapper) {
            priceWrapper.dataset.productBasePrice = event.detail.variant.price
            priceWrapper.removeAttribute('data-default-price-html')
          })

          var selectedAddon = productSection.querySelector('[data-product-addon-item].is-selected')
          updateProductAddonPrice(productSection, selectedAddon)
        }
      })

      productSection.dataset.webdevQuickAtcMounted = 'true'
    })
  }

  function initCustRecentViewSlider(sliderElement) {
    if (!sliderElement || sliderElement.dataset.webdevMounted === 'true') return
    if (typeof window.Splide === 'undefined') return

    var slideCount = sliderElement.querySelectorAll('.cust-recent-view__slide').length
    if (slideCount < 1) return

    var desktopPerPage = parseInt(sliderElement.dataset.perPage, 10) || 3
    var currentPerPage = desktopPerPage

    if (window.matchMedia('(max-width: 749px)').matches) {
      currentPerPage = 1
    } else if (window.matchMedia('(max-width: 989px)').matches) {
      currentPerPage = 2
    }

    if (slideCount <= currentPerPage) {
      sliderElement.classList.add('is-static')
      sliderElement.dataset.webdevMounted = 'true'
      return
    }

    var slider = new window.Splide(sliderElement, {
      type: 'slide',
      perPage: desktopPerPage,
      perMove: 1,
      gap: '2rem',
      arrows: false,
      pagination: true,
      drag: true,
      speed: parseInt(sliderElement.dataset.speed, 10) || 600,
      rewind: false,
      i18n: {
        carousel: 'recently viewed products carousel',
        slide: 'recently viewed product',
        slideLabel: '%s of %s',
        pageX: 'Go to product page %s'
      },
      breakpoints: {
        989: {
          perPage: 2,
          gap: '1.6rem'
        },
        749: {
          perPage: 1,
          gap: '1.4rem'
        }
      },
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0
      }
    })

    slider.on('destroy', function () {
      sliderElement.dataset.webdevMounted = 'false'
    })

    slider.mount()
    sliderElement.webdevCustRecentViewSlider = slider
    sliderElement.dataset.webdevMounted = 'true'
  }

  function initCustRecentViewSections() {
    document.querySelectorAll('[data-cust-recent-view-slider]').forEach(initCustRecentViewSlider)
  }

  function getRecentViewQuery(container) {
    var items = []

    try {
      items = JSON.parse(window.localStorage.getItem('cc-recently-viewed') || '[]')
    } catch (error) {
      items = []
    }

    if (container.dataset.exclude) {
      var excludedId = Number(container.dataset.exclude)
      items = items.filter(function (item) {
        return Number(item) !== excludedId
      })
    }

    return items
      .slice(0, parseInt(container.dataset.limit, 10) || 8)
      .map(function (item) {
        return 'id:' + item
      })
      .join(' OR ')
  }

  function initCustRecentViewContainer(container) {
    if (!container || container.dataset.webdevLoaded === 'true') return
    if (!container.dataset.url) return

    var query = getRecentViewQuery(container)
    if (!query) {
      container.hidden = true
      return
    }

    container.dataset.webdevLoaded = 'true'

    fetch(container.dataset.url + '&q=' + encodeURIComponent(query))
      .then(function (response) {
        if (!response.ok) throw new Error(response.status)
        return response.text()
      })
      .then(function (html) {
        var template = document.createElement('template')
        template.innerHTML = html
        var fetchedContainer = template.content.querySelector('cust-recent-view')

        if (!fetchedContainer || !fetchedContainer.hasChildNodes()) {
          container.hidden = true
          return
        }

        container.innerHTML = fetchedContainer.innerHTML
        container.hidden = false
        initCustRecentViewSections()
        initCustomProductMediaSliders()
      })
      .catch(function () {
        container.hidden = true
      })
  }

  function initCustRecentViewContainers() {
    document.querySelectorAll('cust-recent-view').forEach(initCustRecentViewContainer)
  }

  function updateBraceletLineProgress(sliderElement, slider) {
    var total = sliderElement.querySelectorAll('.custom-bracelet-collection__slide:not(.splide__slide--clone)').length
    var countElement = sliderElement.querySelector('[data-bracelet-line-count]')
    var barElement = sliderElement.querySelector('[data-bracelet-line-bar]')
    var perPage = Math.max(1, Math.round(Number(slider.options.perPage) || 1))
    var visibleEnd = Math.min(total, slider.index + perPage)
    var percent = total > 0 ? (visibleEnd / total) * 100 : 0

    if (countElement) countElement.textContent = visibleEnd + '/' + total
    if (barElement) barElement.style.width = percent + '%'
  }

  function initBraceletLineSlider(sliderElement) {
    if (!sliderElement || sliderElement.dataset.webdevMounted === 'true') return
    if (typeof window.Splide === 'undefined') return

    var slideCount = sliderElement.querySelectorAll('.custom-bracelet-collection__slide').length
    if (slideCount < 1) return

    var desktopPerPage = parseInt(sliderElement.dataset.perPage, 10) || 3
    var currentPerPage = desktopPerPage

    if (window.matchMedia('(max-width: 749px)').matches) {
      currentPerPage = 1
    } else if (window.matchMedia('(max-width: 989px)').matches) {
      currentPerPage = 2
    }

    if (slideCount <= currentPerPage) {
      sliderElement.classList.add('is-static')
      sliderElement.dataset.webdevMounted = 'true'
      updateBraceletLineProgress(sliderElement, {
        index: 0,
        options: {
          perPage: desktopPerPage
        }
      })
      return
    }

    var slider = new window.Splide(sliderElement, {
      type: 'loop',
      perPage: desktopPerPage,
      perMove: 1,
      gap: '2rem',
      arrows: slideCount > 1,
      pagination: false,
      drag: false,
      speed: parseInt(sliderElement.dataset.speed, 10) || 600,
      rewind: false,
      i18n: {
        prev: 'Previous bracelet products',
        next: 'Next bracelet products',
        carousel: 'bracelet line carousel',
        slide: 'bracelet product',
        slideLabel: '%s of %s'
      },
      breakpoints: {
        989: {
          perPage: 2,
          gap: '1.6rem'
        },
        749: {
          perPage: 1,
          gap: '1.4rem'
        }
      },
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0
      }
    })

    slider.on('mounted moved resized updated', function () {
      updateBraceletLineProgress(sliderElement, slider)
    })

    slider.on('mounted', function () {
      window.requestAnimationFrame(function () {
        slider.refresh()
        sliderElement.classList.add('is-loop-ready')
      })
    })

    slider.on('destroy', function () {
      sliderElement.dataset.webdevMounted = 'false'
    })

    slider.mount()
    sliderElement.webdevBraceletLineSlider = slider
    sliderElement.dataset.webdevMounted = 'true'
    updateBraceletLineProgress(sliderElement, slider)
  }

  function initBraceletLineSliders() {
    document.querySelectorAll('[data-bracelet-line-slider]').forEach(initBraceletLineSlider)
  }

  function initWebdevSections() {
    initBannerSliders()
    initTestimonialSliders()
    initCustomVideos()
    initCustomProductMediaSliders()
    initProductDetailGalleries()
    initProductAddonPickers()
    initCustRecentViewContainers()
    initCustRecentViewSections()
    initBraceletLineSliders()
  }

  document.addEventListener('DOMContentLoaded', initWebdevSections)
  document.addEventListener('submit', handleProductAddonSubmit, true)
  document.addEventListener('shopify:section:load', initWebdevSections)
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-wd-banner-slider]').forEach(function (sliderElement) {
      if (sliderElement.webdevBannerSlider) {
        sliderElement.webdevBannerSlider.destroy(true)
      }
    })

    event.target.querySelectorAll('[data-wd-testimonial-slider]').forEach(function (sliderElement) {
      if (sliderElement.webdevTestimonialSlider) {
        sliderElement.webdevTestimonialSlider.destroy(true)
      }
    })

    event.target.querySelectorAll('[data-custom-video]').forEach(function (videoWrap) {
      resetCustomVideo(videoWrap)
      videoWrap.dataset.webdevVideoMounted = 'false'
    })

    event.target.querySelectorAll('[data-custom-product-media-slider]').forEach(function (sliderElement) {
      if (sliderElement.webdevProductMediaSlider) {
        sliderElement.webdevProductMediaSlider.destroy(true)
      }
    })

    event.target.querySelectorAll('[data-wd-product-gallery]').forEach(function (gallery) {
      if (gallery.webdevMainProductGallery) {
        gallery.webdevMainProductGallery.destroy(true)
      }

      if (gallery.webdevZoomModal) {
        gallery.webdevZoomModal.remove()
      }
    })

    event.target.querySelectorAll('[data-cust-recent-view-slider]').forEach(function (sliderElement) {
      if (sliderElement.webdevCustRecentViewSlider) {
        sliderElement.webdevCustRecentViewSlider.destroy(true)
      }
    })

    event.target.querySelectorAll('[data-bracelet-line-slider]').forEach(function (sliderElement) {
      if (sliderElement.webdevBraceletLineSlider) {
        sliderElement.webdevBraceletLineSlider.destroy(true)
      }
    })
  })
  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('[data-wd-banner-slider]').forEach(syncSlideVideos)
  })
})()
